import { render } from "./investmentCompanys.vue?vue&type=template&id=5707c6d3&scoped=true"
import script from "./investmentCompanys.vue?vue&type=script&lang=js"
export * from "./investmentCompanys.vue?vue&type=script&lang=js"

import "./investmentCompanys.vue?vue&type=style&index=0&id=5707c6d3&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5707c6d3"]])

export default __exports__